const BASE_PATH = '/quality/control/site'

export default {
  getDetail: siteId => ({
    url: `${BASE_PATH}/${siteId}/qc-factor-category`,
    method: 'GET'
  }),
  save: (siteId, data) => ({
    url: `${BASE_PATH}/${siteId}/qc-factor-category`,
    method: 'PUT',
    data
  })
}



// WEBPACK FOOTER //
// ./src/apis/modules/QCFactorCategory.js